import * as React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../reducers";
import { Redirect } from "react-router";

const checkNotAuth = (Component: React.FC) => {
  // Higher Order Component that only displays component(that it takes as input) if it is authenticated
  const AuthRoute = () => {
    const isAuthenticated = useSelector(
      (state: RootState) => state.auth.isAuthenticated
    );

    if (!isAuthenticated) {
      return <Component />;
    }
    return <Redirect to="/" />;
  };
  return AuthRoute;
};

export default checkNotAuth;
